import { performGetRequest } from '../helpers/service'

export const getFaqs = async () => {
  const response = await performGetRequest('faqs')

  return response
}
